import { render } from "./PinRequestModal.vue?vue&type=template&id=d6a20786"
import script from "./PinRequestModal.vue?vue&type=script&lang=js"
export * from "./PinRequestModal.vue?vue&type=script&lang=js"

import "./PinRequestModal.vue?vue&type=style&index=0&id=d6a20786&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__